import {
  ChartPieIcon,
  PhoneIcon,
  FolderIcon,
  UsersIcon,
  LightningBoltIcon,
  CurrencyDollarIcon,
  DocumentReportIcon,
  RefreshIcon,
} from "@heroicons/react/outline";
export interface FeatureWithIcon {
  name: string;
  description: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

const features: FeatureWithIcon[] = [
  {
    name: "Live Support",
    description: "Contact our support team by phone, email, or chat.",
    icon: PhoneIcon,
  },
  {
    name: "Built for Speed",
    description:
      "Our workflows take minutes, not hours, to handle legal tasks.",
    icon: LightningBoltIcon,
  },
  {
    name: "Document Storage",
    description:
      "Stay organized with all of your important corporate docs securely stored in one place.",
    icon: FolderIcon,
  },
  {
    name: "Easy for Teams",
    description:
      "Easy esignature workflows make it simple for co-founders to incorporate and grow together",
    icon: UsersIcon,
  },

  {
    name: "VC Ready",
    description:
      "Follow the best practices of experienced founders and investors.",
    icon: DocumentReportIcon,
  },
  {
    name: "Free for Founders",
    description: "We grow with you. No credit card required.",
    icon: CurrencyDollarIcon,
  },
  {
    name: "Stay in Sync",
    description:
      "Our tools work seamlessly together, pre-generating workflows based on your existing company profile.",
    icon: RefreshIcon,
  },
  {
    name: "All-in-One",
    description:
      "Skip the messy onboarding to other cap table platforms. We'll build yours automatically after incorporation.",
    icon: ChartPieIcon,
  },
];

const BlueFeatureSection: React.FC = ({}) => {
  return (
    <div className="bg-gradient-to-r from-blue-800 to-blue-700">
      <div className="max-w-4xl mx-auto px-4 py-16 sm:px-6 sm:pt-20 sm:pb-24 lg:max-w-7xl lg:pt-24 lg:px-8">
        <h2 className="text-3xl font-extrabold text-white tracking-tight">
          Built for startups
        </h2>
        <p className="mt-4 max-w-3xl text-lg text-blue-200">
          Handle legal tasks quickly and easily so you can get back to building.
        </p>
        <div className="mt-12 grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2 lg:mt-16 lg:grid-cols-4 lg:gap-x-8 lg:gap-y-16">
          {features.map((feature) => (
            <div key={feature.name}>
              <div>
                <span className="flex items-center justify-center h-12 w-12 rounded-md bg-white bg-opacity-10">
                  <feature.icon
                    className="h-6 w-6 text-white"
                    aria-hidden="true"
                  />
                </span>
              </div>
              <div className="mt-6">
                <h3 className="text-lg font-medium text-white">
                  {feature.name}
                </h3>
                <p className="mt-2 text-base text-blue-200">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlueFeatureSection;
